import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useCampaignClearEffects from '../useCampaignClearEffects'
import usePermissions from '../../../../hooks/usePermissions'

import { insertIf } from '../../../../helpers/common'

import { openForm } from '../../../../modules/actions/forms'
import { updateCampaign } from '../../../../modules/actions/campaigns'
import { selectedTikTokAdAccountSelector } from '../../../../modules/selectors/adAccounts'

import { listItemChangeStatus } from '../../../../constants/other'
import { CAMPAIGN_TIKTOK_EDIT, CHANGE_CAMPAIGN_HISTORY } from '../../../../constants/forms'
import { TIKTOK_PLATFORM } from '../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../constants/changeHistory'

const useGetTikTokCampaignActions = () => {
  const dispatch = useDispatch()

  const permissions = usePermissions()

  const { id: tikTokAdAccountId } = useSelector(selectedTikTokAdAccountSelector)

  useCampaignClearEffects()

  return useCallback(
    ({ id, status }) => {
      return [
        ...insertIf(permissions.can('update', 'Campaign'), {
          text: 'Edit',
          onClickHandler: () => dispatch(openForm({ id, formName: CAMPAIGN_TIKTOK_EDIT }))
        }),
        ...insertIf(permissions.can('update', 'Campaign'), {
          text: status === 'active' ? 'Pause' : 'Activate',
          onClickHandler: () => {
            dispatch(
              updateCampaign(
                {
                  status: listItemChangeStatus[status].changeTo,
                  account: tikTokAdAccountId,
                  meta: {
                    [HISTORY_META_EDIT_SECTION]: 'Status'
                  }
                },
                id,
                TIKTOK_PLATFORM
              )
            )
          }
        }),
        {
          text: 'Change History',
          onClickHandler: () => dispatch(openForm({ id, formName: CHANGE_CAMPAIGN_HISTORY }))
        }
      ]
    },
    [dispatch, tikTokAdAccountId, permissions]
  )
}

export default useGetTikTokCampaignActions
